import { css, cx } from '@linaria/core';
import { baseTheme, flex } from 'styles/utils';
export const visibilityBadgeStyles = cx("omponents__Visibility__Visibility_styles_tsx-visibilityBadgeStyles-v9aa339", flex.init, flex.alignItems.center);

require("./Visibility.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Visibility.styles.tsx");